import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-svgVideoMoreDisable",
  "use": "icon-svgVideoMoreDisable-usage",
  "viewBox": "0 0 96 96",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 96 96\" id=\"icon-svgVideoMoreDisable\">\n<style type=\"text/css\">\n\t\n\t\t#icon-svgVideoMoreDisable .st0{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:#208060;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:20;}\n</style>\n<g>\n\t<path class=\"st0\" d=\"M34,10l36,38L34,86\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol